import ViewModel from '@/ViewModels/ViewModel';
import GenericObject from '@/Model/GenericObject';
import * as CoreFrameInterfaces from '#/CoreFrameInterfaces';
import BusyCounter from '@/Utility/BusyCounter';

export default class SummaryViewModel extends ViewModel {

    public genericObject: GenericObject;

    /** 
     * Gibt an, ob die SummaryView derzeit geladen wird
     */
    public isBusy: KnockoutObservable<boolean>;
    private busyCounter: BusyCounter;

    /**
     * Gibt an, ob die Instanz disposed werden kann
     */
    public isDisposable: boolean;


    constructor(params: CoreFrameInterfaces.ISummaryViewModelConstructorParameter) {
        super(params);

        this.genericObject = this.paramOrDefault(params.genericObject, null);

        this.isBusy = this.observableOrDefault(params.isBusy, false);

        this.isDisposable = this.paramOrDefault(true);
    }

    public increaseBusyCounter(): void {
        if (this.isDisposed)
            return;

        if (!this.busyCounter)
            this.busyCounter = new BusyCounter(this.isBusy);

        this.busyCounter.increment();
    }

    public decreaseBusyCounter(): void {
        if (this.isDisposed || !this.busyCounter)
            return;

        this.busyCounter.decrement();
    }
}